import ExportFullShop from "../../components/import/exportFullShop.comp";
import ImportFullShop from "../../components/import/importFullShop.comp";
import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";

export default function ImportShopPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.import.importExportWholeShop)}>
      <ExportFullShop />
      <ImportFullShop />
    </Layout>
  );
}
